import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'semantic-ui-react';
import { Formik } from 'formik';
import { FormattedMessage } from 'react-intl';
import * as yup from 'yup';
import { FormComponents } from '../components';
import { getErrorMessage } from '../utils/validations';

const WarrantyRegForm = ({ userId, error }) => {
  const validationSchema = yup.object().shape({
    sn: yup.string().required(getErrorMessage({ key: 'required' }))
  });

  // append any form values to the external warranty registration page link
  const onSubmit = (values, { resetForm }) => {
    let query =
      (values && Object.keys(values).map(key => `${key}=${values[key]}`)) || [];
    query = query.concat(`session=${userId}`);
    window.open(`${process.env.REACT_APP_WARRANTY}?${query.join('&')}`);
    resetForm(values);
  };

  return userId ? (
    <Formik
      validationSchema={validationSchema}
      onSubmit={onSubmit}
      initialValues={{ sn: '' }}
    >
      {({ handleSubmit, isValid, errors, touched }) => (
        <Form
          onSubmit={handleSubmit}
          error={!!error}
          className="form--compact"
          ref={form => (this.form = form)}
        >
          <FormComponents.Field
            type="text"
            name="sn"
            data-qa="serial-no-field"
            label={
              <FormattedMessage
                id="form.serial_number"
                description="Serial Number field label"
                defaultMessage="Serial No."
              />
            }
            error={touched.sn && errors.sn}
          />

          {!isValid && <FormComponents.FormError error={error} />}
          <a onClick={handleSubmit}>
            <strong data-qa="button-begin-registration">
              <FormattedMessage
                id="cta.warranty_reg_description"
                description="Warranty Registration submit button label"
                defaultMessage="Begin Registration"
              />
            </strong>
          </a>
        </Form>
      )}
    </Formik>
  ) : null;
};

WarrantyRegForm.propTypes = {
  userId: PropTypes.string,
  error: PropTypes.string,
  onSubmit: PropTypes.func
};

export default WarrantyRegForm;



// WEBPACK FOOTER //
// ./src/forms/WarrantyRegForm.js